// removed by extract-text-webpack-plugin
module.exports = {"filled":"_2rR0GmN","spring":"zSHOLlr"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/seek-style-guide/react/icons/StarIcon/StarIcon.less
 ** module id = 651
 ** module chunks = 0
 **/